import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useHeaderContext } from '~/components/layout/Header/HeaderContext';
import { categoriesMenu } from '~/components/layout/Header/data';
import Container from '~/components/ui/Container';
import { cn } from '~/helpers/utils';

const NavigationMegaMenus = () => {
  const { openMenu, onMenuEnter, onMenuLeave } = useHeaderContext();

  const linkClasses = cn(
    'flex items-center gap-2 py-2 text-sm font-medium no-underline transition-colors',
    'text-blue-800 hover:text-blue-600',
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500'
  );

  return (
    <div
      className={cn(
        'absolute left-0 right-0 top-full z-50',
        'border-stone-200 bg-white transition-all duration-300',
        openMenu === 'categories' && 'border-t shadow-xl'
      )}
    >
      <div
        className={cn(
          'relative grid overflow-hidden transition-all duration-300',
          openMenu === 'categories' ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
        )}
        aria-hidden={openMenu !== 'categories'}
        onMouseEnter={onMenuEnter}
        onMouseLeave={onMenuLeave}
      >
        <div className="min-h-0">
          <Container
            className={cn(
              'relative pb-10 pt-8 transition-all duration-500',
              openMenu === 'categories'
                ? 'translate-y-0 opacity-100'
                : 'translate-y-25 opacity-0'
            )}
          >
            <span className="mb-2.5 inline-block font-display text-xl font-bold text-black">
              Vind adviseurs per categorie
            </span>
            <div className="grid grid-cols-3 gap-6">
              {categoriesMenu.map((column, index) => (
                <div
                  key={column.heading}
                  className={cn(index === 0 && 'col-span-2')}
                >
                  <p className="mb-3 text-xs font-semibold uppercase tracking-wide text-blue-600">
                    {column.heading}
                  </p>
                  {index === 0 ? (
                    <div className="grid grid-cols-2 gap-x-6">
                      {[
                        column.links.slice(
                          0,
                          Math.ceil(column.links.length / 2)
                        ),
                        column.links.slice(Math.ceil(column.links.length / 2)),
                      ].map((half, i) => (
                        <ul key={i} className="space-y-0.5">
                          {half.map((link) => (
                            <li key={link.href}>
                              <a href={link.href} className={linkClasses}>
                                <FontAwesomeIcon
                                  icon={faArrowRight}
                                  className="text-blue-500"
                                />
                                {link.label}
                              </a>
                            </li>
                          ))}
                        </ul>
                      ))}
                    </div>
                  ) : (
                    <ul className="space-y-0.5">
                      {column.links.map((link) => (
                        <li key={link.href}>
                          <a href={link.href} className={linkClasses}>
                            <FontAwesomeIcon
                              icon={faArrowRight}
                              className="text-blue-500"
                            />
                            {link.label}
                          </a>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          </Container>
        </div>
      </div>
    </div>
  );
};

export default NavigationMegaMenus;
